import { Link } from 'react-router-dom';

interface BrandLogoProps {
  compact?: boolean;
}

const BrandLogo = ({ compact = false }: BrandLogoProps) => {
  return (
    <Link
      to="/"
      className={`brand-logo ${compact ? 'brand-logo-compact' : ''}`}
      aria-label="CertificationISO home"
    >
      <span className="brand-logo-mark" aria-hidden="true">
        <svg viewBox="0 0 64 64" role="img" focusable="false" width="64" height="64">
          <defs>
            <linearGradient id="brandGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#2563eb" />
              <stop offset="100%" stopColor="#14b8a6" />
            </linearGradient>
          </defs>
          <circle cx="32" cy="32" r="27" fill="none" stroke="url(#brandGradient)" strokeWidth="6" />
          <path
            d="M42 22c-2.6-3.5-6.6-5.8-11.2-5.8C23 16.2 16.6 22.6 16.6 31s6.4 14.8 14.2 14.8c4.6 0 8.6-2.3 11.2-5.8"
            fill="none"
            stroke="#0f172a"
            strokeWidth="7"
            strokeLinecap="round"
          />
          <path
            d="M26 26h12M26 32h10"
            fill="none"
            stroke="#ffffff"
            strokeWidth="3.5"
            strokeLinecap="round"
            opacity="0.92"
          />
          <path d="M38 20l-4 10" fill="none" stroke="#14b8a6" strokeWidth="3" strokeLinecap="round" />
        </svg>
      </span>
      <span className="brand-logo-text">
        <strong>CertificationISO</strong>
        {!compact && <small>certificationiso.com</small>}
      </span>
    </Link>
  );
};

export default BrandLogo;
